import { Anchor } from '@zillow/constellation-10';
import { css } from '@/styled-system/css';
// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
import { styled } from '@/styled-system/jsx';

export const floatingWidgetStyles = css.raw({
  bottom: 0,
  display: 'flex',
  flexDirection: 'column',
  margin: '0 20px 20px 0',
  position: 'fixed',
  right: 0,
  width: 'auto',
  zIndex: '9999',
  alignItems: 'flex-end',
  justifyContent: 'flex-end',
  padding: '400',
});

// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
export const StyledAnchor = styled(Anchor, {
  base: {
    color: 'text.neutral !important',
  },
});
